export function requestTransacoes(params) {
	return {
		type: '@clientTransacoes/REQUEST',
		payload: params,
	};
}

export function successTransacoes(dados) {
	return {
		type: '@clientTransacoes/SUCCESS',
		payload: { dados },
	};
}

export function failureTransacoes(error) {
	return {
		type: '@clientTransacoes/FAILURE',
		payload: { error },
	};
}
